/**************
 Cart
 ***************/

// Define maximum quantity
const MAX_QUANTITY =  document.querySelector('#miniCart').dataset.productMaxQuantity;; // Set this to your desired maximum quantity or retrieve it dynamically

// Function to show a message
function showMessage(message) {
    const messageContainer = document.createElement("div");
    messageContainer.className = "quantity-limit-message";
    messageContainer.textContent = message;
    document.body.appendChild(messageContainer);

    setTimeout(() => {
        messageContainer.remove();
    }, 3000);
}


// Function to update button states
function updateButtonStates(element, quantity) {
    const minusButton = element.querySelector(".miniCartBodyItemQuantityMinus");
    const plusButton = element.querySelector(".miniCartBodyItemQuantityPlus");

    if (quantity <= 1) {
        minusButton.setAttribute("disabled", "true");
    } else {
        minusButton.removeAttribute("disabled");
    }

    if (quantity >= MAX_QUANTITY) {
        plusButton.setAttribute("disabled", "true");
    } else {
        plusButton.removeAttribute("disabled");
    }
}

// open cart
async function openCart(skipFetch = false) {
    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // hide all sections
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartHeader").classList.remove("active");
    document.querySelector("#miniCartBody").classList.remove("active");
    document.querySelector("#miniCartUpsell").classList.remove("active");
    document.querySelector("#miniCartPrice").classList.remove("active");
    document.querySelector("#miniCartFooter").classList.remove("active");

    // start loading on the cart
    document.querySelector("#miniCartContent").classList.add("loading");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // stop loading on the cart
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerCart').setAttribute("data-count", cart.item_count);
    document.querySelector("#miniCartHeaderTitle span").textContent = `${cart.item_count} Item${cart.item_count === 1 ? "" : "s"}`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartPrice").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // does this order contain a subscription (free shipping)
    let cartPrice = cart.total_price / 100;
    if (cartPrice >= shippingThreshold) {
        document.querySelector("#miniCartHeaderShippingLeft").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
        document.querySelector("#miniCartHeaderBarInner").style.width = "100%";
    } else {
        document.querySelector("#miniCartHeaderShippingLeft").innerHTML = `<span>$${(shippingThreshold - cartPrice).toFixed(2)}</span> to get free shipping!`;
        document.querySelector("#miniCartHeaderBarInner").style.width = `${(cartPrice / shippingThreshold) * 100}%`;
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            /****************** discount ******************/

            let comparePrice = null
            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
            }
            // check for line item discount
            else if (item.original_line_price > item.final_line_price) {
                comparePrice = item.original_line_price;
            }
            // check for compare at price
            else if (variantIDToCompareAtPrice[item.variant_id] > item.final_price) {
                comparePrice = variantIDToCompareAtPrice[item.variant_id] * item.quantity;
            }

            /***************** savings *****************/

                // check for savings
            let savings = null;
            if (comparePrice) {
                savings = comparePrice - item.final_line_price;

                return `<div>
                        <div class="miniCartBodyItemPrice"><span>${price(comparePrice, false)}</span>${price(item.final_line_price, false)}</div>
                        <div class="miniCartBodyItemSavings">Save ${price(savings, false)}</div>
                    </div>`;
            } else {
                return `<div class="miniCartBodyItemPrice">${price(item.final_line_price, false)}</div>`;
            }
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" key="${item.key}">
                <div class="miniCartBodyItemInner">
                    <img class="miniCartBodyItemImage" src="${item.image}&width=200">
                    <div class="miniCartBodyItemFlex">
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${subscriptionHTML()}
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">+</button>
                        </div>
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <button class="miniCartBodyItemRemove">
                            <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.28125 4.15625L3.86719 13.5312C3.89502 14.0729 4.28906 14.4688 4.80469 14.4688H10.1953C10.713 14.4688 11.0997 14.0729 11.1328 13.5312L11.7188 4.15625" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.34375 4.15625H12.6562" stroke="#8F8F8F" stroke-width="0.9375" stroke-miterlimit="10" stroke-linecap="round"/>
                                <path d="M9.60938 6.03125L9.375 12.5938M7.5 6.03125V12.5938M5.39062 6.03125L5.625 12.5938M5.625 4.15625V2.98438C5.62473 2.89197 5.64273 2.80041 5.67797 2.71498C5.71321 2.62955 5.76499 2.55193 5.83034 2.48659C5.89568 2.42124 5.9733 2.36946 6.05873 2.33422C6.14416 2.29898 6.23572 2.28098 6.32812 2.28125H8.67188C8.76429 2.28098 8.85584 2.29898 8.94127 2.33422C9.0267 2.36946 9.10432 2.42124 9.16966 2.48659C9.23501 2.55193 9.28679 2.62955 9.32203 2.71498C9.35727 2.80041 9.37527 2.89197 9.375 2.98438V4.15625H5.625Z" stroke="#8F8F8F" stroke-width="0.9375" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                        ${priceHTML()}
                    </div>
                </div>
                <div class="miniCartBodyItemSubscription">
                    <button class="miniCartBodyItemSubscriptionButton">Subscribe & Save (15%)</button>
                    <select class="miniCartBodyItemSubscriptionSelect"
                        name="sellingPlan"
                        aria-label="subscription select">
                    </select>
                </div>
            </div>
        `);

        // add active to subscribe button if subscription is active
        if (item.selling_plan_allocation) {
            document.querySelector(`.miniCartBodyItem[key="${item.key}"] .miniCartBodyItemSubscriptionButton`).classList.add("active");
        }

        // if there are selling plans, go through the list and add each
        let sellingPlans = variantSellingPlans[item.id];
        if (sellingPlans?.length > 0) {
            function subscriptionOptionsHTML() {
                sellingPlans.forEach(plan => {
                    let option = document.createElement("option");
                    if (plan.name === item.selling_plan_allocation?.selling_plan.name) {
                        option.selected = true;
                    }
                    option.value = plan.id;
                    option.textContent = plan.name;
                    document.querySelector(`.miniCartBodyItem[key="${item.key}"] .miniCartBodyItemSubscriptionSelect`).appendChild(option);
                })
            }

            subscriptionOptionsHTML();
        } else {
            document.querySelector(`.miniCartBodyItem[key="${item.key}"] .miniCartBodyItemSubscription`).remove();
        }
    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

       // Intialize the max quantity
        updateButtonStates(element, quantity) 
      
        // minus
         element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            if (quantity >= MAX_QUANTITY) {
                showMessage("You have reached the maximum quantity limit.");
            
            } else {
                quantity++;
                updateCartItem();
            
            }
        
        });
       

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();

            // fade out and remove
            element.classList.add("fade");
            setTimeout(() => {
                element.remove();
            }, 500);
        });

        // update quantity function
        async function updateCartItem(subscription = false) {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // update cart in shopify
            cart = await changeCart({
                id: key,
                quantity: quantity
            });

            // update active body
            await openCart(true);
        }

        // // setup item subscription update
        element.querySelector('.miniCartBodyItemSubscriptionButton')?.addEventListener('click', function () {
            if (this.classList.contains('active')) {
                this.classList.remove('active');
                updateWithSubscribe(false)
                return;
            }
            this.classList.add('active');
            updateWithSubscribe(true)
        })

        // subscription select -  if subscription is active, update cart
        element.querySelector('.miniCartBodyItemSubscriptionSelect')?.addEventListener('change', function () {
            if (!element.querySelector('.miniCartBodyItemSubscriptionButton').classList.contains('active')) return;
            updateWithSubscribe(true);
        });

        async function updateWithSubscribe(subscribe) {
            // check if this is removing subscription
            let subscriptionId = null;
            if (subscribe) {
                subscriptionId = element.querySelector('.miniCartBodyItemSubscriptionSelect').value;
            }

            // update cart in shopify
            cart = await changeCart({
                id: key,
                quantity: quantity,
                selling_plan: subscriptionId
            });

            await openCart(true);
        }

    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem")?.forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.some(item => item.product_id === productID);
        // hide if already in the cart
        if (isProductInCart) {
            element.remove();
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }

    // add price to ATC button
    document.querySelector("#miniCartPriceNumber").textContent = price(cart.items_subtotal_price);
}

// Add Upsell function
document.querySelectorAll('.UpsellItemATC').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from element
        const variantID = this.closest('.upSellItemInfo').dataset.variant;

        // add loading animation
        this.classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        if (this.parentElement.classList.contains('cartUpsellItemBody')) {
            location.reload();
        } else {
            await openCart();
        }

    });
});

// checkout redirect
document.querySelector('#miniCartFooterCheckout').addEventListener('click', () => {
    window.location.href = '/cart';
})

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", openCart);
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
    document.querySelector("body").classList.remove("noScroll");
}

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));
